

export { KnockoutView, PureKnockoutView } from './src/index';
